import React, { useState, useEffect } from 'react';
import {
    RequestEditTaskPaymentsSignal,
    RequestUpdateEntryDialogsLayout,
    EVENT_KEYS
} from 'presentation/events';
import {
    mediateEditEntryPaymentsInfoDependent,
    mediateEditEntryPaymentsRequester,
    mediateEntryDialogsLayoutInfoDependent,
    mediateAddEntryRequester,
    mediateRequestUpdateEntryDialogsLayout,
} from 'mediators';
import { AddEntrySignal } from 'presentation/events';
import { EntryDialog } from './EntryDialog';
import { useSelector, useDispatch } from 'react-redux';

// TasksDialogs now only handles the payments sub-entry dialog.
// Add/edit entry is handled inline in Tasks.tsx.
export const TasksDialogs = () => {
    const dispatch = useDispatch();
    const paymentTask: any = useSelector(mediateEditEntryPaymentsInfoDependent);
    const entryDialogsLayout: any = useSelector(mediateEntryDialogsLayoutInfoDependent);
    const [requestEditTaskPaymentsSignal] = useState(new RequestEditTaskPaymentsSignal());
    const [addEntrySignal] = useState(new AddEntrySignal());
    const [requestUpdateEntryDialogsLayout] = useState(new RequestUpdateEntryDialogsLayout());

    useEffect(() => {
        return mediateRequestUpdateEntryDialogsLayout(requestUpdateEntryDialogsLayout, dispatch).destroy;
    }, [requestUpdateEntryDialogsLayout, dispatch]);

    useEffect(() => {
        return mediateAddEntryRequester(addEntrySignal, dispatch).destroy;
    }, [addEntrySignal, dispatch]);

    useEffect(() => {
        return mediateEditEntryPaymentsRequester(requestEditTaskPaymentsSignal, dispatch).destroy;
    }, [requestEditTaskPaymentsSignal, dispatch]);

    const handlePayment = (title, amount, type, tag, dueDate, reminderDate) => {
        requestEditTaskPaymentsSignal.dispatch();
        addEntrySignal.dispatch({
            title,
            amount,
            type,
            parent: paymentTask.id,
            tag,
            dueDate,
            reminderDate,
            isReminderOn: !!reminderDate,
            insertOrder: paymentTask.order + 1,
        });
    };

    const handleCancelPayment = () => {
        requestEditTaskPaymentsSignal.dispatch();
        requestUpdateEntryDialogsLayout.dispatch({ dialogEvent: EVENT_KEYS.SHOW_EDIT_ENTRY_PAYMENTS, show: false });
    };

    return (
        <>
            {paymentTask && (
                <EntryDialog
                    handleClose={handleCancelPayment}
                    action={handlePayment}
                    parent={paymentTask.id}
                    lockParent={true}
                    type="DEBIT"
                    title="Add sub-entry"
                    open={entryDialogsLayout?.showEditEntryPayments || false}
                />
            )}
        </>
    );
};
